// extracted by mini-css-extract-plugin
module.exports = {"navLink":"style_navLink__-xzl8","icon":"style_icon__2mCMJ"};